import {Location} from 'react-router';
import {DocumentSection, DocumentSectionExcerpt} from '@/engine';
import {getAnalyticsDocumentSectionPageName} from '@/services/analytics/get-analytics-document-section-page-name';

export const getAnalyticsDocumentSectionVirtualClickUrl = (
  location: Location,
  documentSection: DocumentSection | DocumentSectionExcerpt,
) => `${location.pathname}${location.search}${location.hash}/${getAnalyticsDocumentSectionPageName(documentSection)}`;
